import { logger } from '@sanlam-glacier/app-common/modules/logger';
import { useParams } from 'react-router';
type ClientUrlParameters = {
  clientId?: string;
};

export const useClientIdFromParams = (): number => {
  const { clientId } = useParams<ClientUrlParameters>();
  if (clientId === undefined)
    logger.warning({
      message: 'Client ID not found in parameters.',
      includeTrace: true
    });
  return Number(clientId);
};
